// import Swiper from 'swiper';

export const sliderNewsBlock = () => {
    const bskSlider = document.querySelectorAll(".bsk-slider");
    document.addEventListener("click", e => {
        const bskTileImage = e.target.closest(".bsk-tile__image");
        if(bskTileImage) {
            bskTileImage.closest(".bsk-tile").querySelector(".bsk-tile__btn").click();
        }
    });
    if(bskSlider.length) {
        // console.log("sliderNewsBlock loaded");
        const swiper = new Swiper(".bsk-slider__swiper", {
            slidesPerView: 1,
            spaceBetween: 32,
            loop: false,
            centeredSlides: false,
            slideVisibleClass: true,
            preloadImages: true,
            navigation: {
                prevEl: '.bsk-slider__swiper-prev',
                nextEl: '.bsk-slider__swiper-next',
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
            breakpoints: {
                576: {
                    slidesPerView: 2,
                },
                992: {
                    slidesPerView: 3,
                },
            }
        })
    }
};
